<kendo-drawer-container
  class="shell-drawer-container"
  [class.shell-drawer-container--launchpad]="hidesSidebar"
  [class.shell-drawer-container--rtl]="isRtl"
>
  <!-- <div style="width:56px;"></div> -->
  <kendo-drawer
    #drawer
    [items]="isMenuItemsLoading ? skeletons : drawerItems"
    [mode]="expandMode"
    [position]="drawerPosition"
    [mini]="true"
    [miniWidth]="56"
    [width]="255"
    [(expanded)]="isMenuShown"
    [autoCollapse]="!isMenuShown"
    (select)="onSelect($event)"
  >
    <ng-template kendoDrawerHeaderTemplate>
      <div class="menu-header-ctx z-10">
        <div
          class="flex items-center menu-header"
        >
          <button class="k-button k-button-clear p-0" (click)="toggleDrawer()">
            <!-- <kendo-icon [name]="'menu'" style="color: white"></kendo-icon> -->
            <img
              class="app-breadcrumb__leading-icon-img"
              src="assets/icons/zeymo-admin.svg"
              alt="menu icons"
            />
          </button>
          @if (isMenuShown) {
            <h2 class="menu-header-text mt-0 mb-0">
              <a class="k-drawer-item" routerLink="/">Zeymo</a>
            </h2>
          }
        </div>

        @if (isMenuShown && isModuleScoped) {
          <a class="menu-scope-back" routerLink="/">
            <span class="k-icon k-font-icon k-i-arrow-left" aria-hidden="true"></span>
            {{ 'launchpadAllModules' | translate }}
          </a>
        }

        <!-- <div
        *ngIf="isMenuShown"
        class="flex items-center p-5"
        >
        <kendo-dropdownbutton
          kendoButton
          [primary]="true"
          [icon]="'plus-outline'"
          [data]="dropdownButtonData"
          (itemClick)="onDropdownButtonItemClick($event)"
          class="w-100"
          buttonClass="k-outline k-primary border-white w-100"
          >
          New
        </kendo-dropdownbutton>
      </div>
      <div
        *ngIf="!isMenuShown"
        class="flex items-center p-5"
        >
        <kendo-dropdownbutton
          kendoButton
          [primary]="true"
          [icon]="'plus-outline'"
          [data]="dropdownButtonData"
          buttonClass="k-primary border-transparent"
          (itemClick)="onDropdownButtonItemClick($event)"
          >
        </kendo-dropdownbutton>
      </div> -->
      </div>
    </ng-template>

    <ng-template kendoDrawerItemTemplate let-item let-index>
      @if (isMenuItemsLoading) {
        <kendo-skeleton
          class="side-menu-skeleton"
          shape="text"
          animation="pulse"
          [width]="item"
          [height]="40"
        ></kendo-skeleton>
      }
      @if (!isMenuItemsLoading) {
        @if (item.path) {
          <a
            kendoTooltip
            class="sidebar-tab menu-item flex justify-between items-center grow"
            [ngClass]="{
              'level-bg sidebar-tab--sub': item.level,
              'sidebar-tab--parent-expanded':
                !item.level &&
                item.expanded &&
                item.children?.length > 0 &&
                isMenuShown
            }"
            [title]="
              item.parentTitle
                ? (item['parentuid'] | translate) +
                  ' / ' +
                  (item.uid | translate)
                : (item.uid | translate)
            "
            [routerLink]="[item.path]"
            routerLinkActive="active"
            position="right"
            [routerLinkActiveOptions]="{ exact: true }"
            [showOn]="isMenuShown ? 'none' : 'hover'"
          >
            <div class="sidebar-tab__content flex items-center min-w-0">
              @if (!item.level) {
                <span class="sidebar-tab__icon-wrap k-level-{{ item.level }}">
                  <span
                    class="k-icon k-font-icon sidebar-tab__icon {{ item.icon }}"
                  ></span>
                </span>
              } @else {
                <span class="sidebar-tab__bullet" aria-hidden="true" [class.is-collapsed]="!isMenuShown"></span>
              }
              <span class="menu-title sidebar-tab__label">
                {{ item.uid | translate }}
              </span>
              @if (item.hasWarnings) {
                <span
                  class="missing-info-notification"
                  [ngClass]="isMenuShown ? null : 'ml-n2'"
                ></span>
              }
            </div>
            @if (isMenuShown && item.expanded && item.children?.length > 0) {
              <span
                class="k-icon k-font-icon k-i-arrow-chevron-down sidebar-tab__chevron sidebar-tab__chevron--expanded"
              ></span>
            }
            @if (isMenuShown && !item.expanded && item.children?.length > 0) {
              <span
                class="k-icon k-font-icon k-i-arrow-chevron-right sidebar-tab__chevron"
              ></span>
            }
          </a>
        } @else {
          <div
            class="sidebar-tab menu-item flex justify-between items-center grow"
            kendoTooltip
            [ngClass]="{
              'level-bg sidebar-tab--sub': item.level,
              'sidebar-tab--parent-expanded':
                !item.level &&
                item.expanded &&
                item.children?.length > 0 &&
                isMenuShown
            }"
            [title]="
              item.parentTitle
                ? (item['parentuid'] | translate) +
                  ' / ' +
                  (item.uid | translate)
                : (item.uid | translate)
            "
            [position]="'right'"
            [showOn]="isMenuShown ? 'none' : 'hover'"
          >
            <div class="sidebar-tab__content flex items-center min-w-0">
              @if (!item.level) {
                <span class="sidebar-tab__icon-wrap k-level-{{ item.level }}">
                  <span
                    class="k-icon k-font-icon sidebar-tab__icon {{ item.icon }}"
                  ></span>
                </span>
              } @else {
                <span class="sidebar-tab__bullet" aria-hidden="true"></span>
              }
              <span class="menu-title sidebar-tab__label">
                {{ item.uid | translate }}
              </span>
              @if (item.hasWarnings) {
                <span
                  class="missing-info-notification"
                  [ngClass]="isMenuShown ? null : 'ml-n2'"
                ></span>
              }
            </div>
            @if (isMenuShown && item.expanded && item["children"]) {
              <span
                class="k-icon k-font-icon k-i-arrow-chevron-up sidebar-tab__chevron sidebar-tab__chevron--expanded mr-3"
              ></span>
            }
            @if (isMenuShown && !item.expanded && item["children"]) {
              <span
                class="k-icon k-font-icon k-i-arrow-chevron-right sidebar-tab__chevron mr-3"
              ></span>
            }
          </div>
        }
      }
    </ng-template>

    <ng-template kendoDrawerFooterTemplate> </ng-template>
  </kendo-drawer>

  <kendo-drawer-content>
    <!-- Using userDropdownAnchor to display the user-dropdown popup attached to this div -->
    <div #userDropdownAnchor></div>
    <kendo-appbar [position]="'top'" class="px-4">
      <!-- Show current route Feature name -->
      <!-- Brand (ZEY-2419): only on the launchpad, which has no sidebar. Everywhere else the sidebar's
           own Zeymo header is the brand (and the way back to the launchpad). -->
      @if (hidesSidebar) {
        <kendo-appbar-section>
          <a class="appbar-brand" routerLink="/" [title]="'launchpadAllModules' | translate">
            <img src="assets/icons/zeymo-admin.svg" alt="" width="28" height="28" />
            <span>Zeymo</span>
          </a>
        </kendo-appbar-section>
      } @else {
        <kendo-appbar-section>
          <app-breadcrumb [generateFromRoute]="true"></app-breadcrumb>
        </kendo-appbar-section>
      }
      <kendo-appbar-spacer></kendo-appbar-spacer>
      <!-- Launchpad module search (ZEY-2419): lives in the header, filters the tiles below -->
      @if (isLaunchpad) {
        <kendo-appbar-section>
          <label class="appbar-search">
            <kendo-icon name="search"></kendo-icon>
            <input
              type="search"
              [placeholder]="'launchpadSearch' | translate"
              [attr.aria-label]="'launchpadSearch' | translate"
              [value]="launchpadSearch.query()"
              (input)="launchpadSearch.query.set($any($event.target).value)"
            />
          </label>
        </kendo-appbar-section>
      }
      <!-- Tenant name -->
      @if (envAndTenantName) {
        <kendo-appbar-section>
          <span class="tenant-name">{{ envAndTenantName }}</span>
        </kendo-appbar-section>
      }
      <!-- Header actions (ZEY-2419): quiet icon buttons with blue count badges, then a divider and the
           signed-in user — the micro-UIs' header look (hr-ui Header.tsx). -->
      <kendo-appbar-section>
        <div class="appbar-actions">
          <!-- Help (ZEY-534): opens the context-aware help drawer for the current screen -->
          <button class="appbar-icon-btn" type="button" title="Help" aria-label="Help" (click)="helpDrawer.open()">
            <kendo-icon name="question-circle"></kendo-icon>
          </button>
          <!-- Messages (ZEY-2259): people-to-people conversations; hidden when the tenant switches messaging off -->
          @if (messagingEnabled) {
            <button
              class="appbar-icon-btn"
              type="button"
              [title]="'messages' | translate"
              [attr.aria-label]="'messages' | translate"
              (click)="messagesDrawer.open()"
            >
              <kendo-icon name="comment"></kendo-icon>
              @if (messagesUnread) {
                <span class="appbar-badge">{{ messagesUnread > 99 ? '99+' : messagesUnread }}</span>
              }
            </button>
          }
          <!-- Approvals (ZEY-2462): shown only while something is waiting on this user -->
          @if (pendingApprovalsCount) {
            <a
              class="appbar-icon-btn"
              [routerLink]="[myApprovalsPath]"
              [title]="'approvals-my' | translate"
              [attr.aria-label]="'approvals-my' | translate"
            >
              <kendo-icon name="check-circle"></kendo-icon>
              <span class="appbar-badge">{{ pendingApprovalsCount > 99 ? '99+' : pendingApprovalsCount }}</span>
            </a>
          }
          <!-- Notification bell (SignalR jobs) -->
          <div class="notif-bell" id="notif-anchor-shell" #notifAnchorShell>
            <button class="appbar-icon-btn" type="button" title="Notifications" aria-label="Notifications" (click)="toggleNotificationsPopup()">
              <kendo-icon name="bell"></kendo-icon>
              @if (bellCount) {
                <span class="appbar-badge">{{ bellCount > 99 ? '99+' : bellCount }}</span>
              }
            </button>
          </div>
        </div>
      </kendo-appbar-section>
      <!-- Signed-in user: avatar, name and role; opens Profile / Logout -->
      <kendo-appbar-section>
        <div class="appbar-user-dropdown">
          <app-user-dropdown [anchor]="userDropdownAnchor" [showName]="true">
          </app-user-dropdown>
        </div>
      </kendo-appbar-section>
    </kendo-appbar>
    <ng-template #dialogActions>
      <button kendoButton (click)="closeDialog()">Discard</button>
      <button kendoButton [primary]="true" (click)="onSubmit()">Save</button>
    </ng-template>
    <div class="router-outlet">
      @if (isSettingsLoaded) {
        <router-outlet></router-outlet>
      }
    </div>
  </kendo-drawer-content>

  <!-- Notification popup content anchored to the bell (outside drawer-content for proper positioning) -->
  @if (isNotificationsPopupOpen && notifAnchorShell) {
    <kendo-popup
      [anchor]="notifAnchorShell"
      [popupClass]="'notif-popup'"
      [offset]="{ top: 10, left: 0 }"
    >
      <div class="notif-container">
        <div class="notif-header">
          <h3>Notifications</h3>
          <div class="notif-header-actions">
            @if (unreadCount > 0) {
              <button
                kendoButton
                look="flat"
                class="mark-all-read"
                (click)="markAllNotificationsRead()"
              >
                Mark all read
              </button>
            }
            <button kendoButton look="flat" (click)="toggleNotificationsPopup()">
              <span class="k-icon k-font-icon k-i-close"></span>
            </button>
          </div>
        </div>
        @if (lastProgress) {
          <div class="notif-progress">
            <div class="file-title">Progress</div>
            <div class="progress-bar">
              <div
                class="progress-fill"
                [style.width.%]="lastProgress?.percentage"
              ></div>
            </div>
            <div class="progress-label">{{ lastProgress?.percentage }}%</div>
          </div>
        }
        <div class="notif-list">
          @for (n of inboxNotifications; track n.uid) {
            <div class="notif-item" [class.unread]="!n.isRead">
              <div class="notif-text">
                <div class="notif-title">{{ n.title }}</div>
                @if (n.body) {
                  <div class="notif-sub">{{ n.body }}</div>
                }
              </div>
              <div class="notif-meta">
                <div class="notif-time">
                  {{ n.createdAt | date: "short" }}
                </div>
                @if (!n.isRead) {
                  <button
                    kendoButton
                    look="flat"
                    class="mark-read"
                    title="Mark as read"
                    (click)="markNotificationRead(n)"
                  >
                    <span class="k-icon k-font-icon k-i-check"></span>
                  </button>
                }
              </div>
            </div>
          }
          @for (n of visibleJobNotifications; track n) {
            <div class="notif-item">
              <div class="notif-text">
                <div class="notif-title">{{ n.message }}</div>
                <div class="notif-sub">{{ n.messageType }}</div>
              </div>
              <div class="notif-meta">
                <div class="notif-time">
                  {{ n.timestamp | date: "shortDate" }}
                </div>
              </div>
            </div>
          }
          @if (inboxNotifications.length === 0 && visibleJobNotifications.length === 0) {
            <div class="empty-notifications">No notifications</div>
          }
        </div>
      </div>
    </kendo-popup>
  }

  <template #componentContainer> </template>

  <!-- In-app help drawer (ZEY-534) — opened by the top-bar help button -->
  <app-help-drawer #helpDrawer></app-help-drawer>

  <!-- Messages panel (ZEY-2259) — opened by the top-bar Messages button or a record's Discuss button -->
  <app-messages-drawer #messagesDrawer></app-messages-drawer>
</kendo-drawer-container>
